// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5SLYu","iconBox":"styles_iconBox__JFTE2","content":"styles_content__5aHDu"};